module.exports = __webpack_public_path__ + "img/Hw-logo-neg.361dd448.svg";